<template>
<div>
<div class="c-breadcrumbs" typeof="BreadcrumbList" vocab="http://schema.org/" style="margin-top: -61px;margin-left: 0px;text-align: left;">
        <span property="itemListElement" typeof="ListItem"><a property="item" typeof="WebPage" title="株式会社ranryu" href="/" class="home"><span property="name">ホーム</span></a><meta property="position" content="1"></span> &gt; <span property="itemListElement" typeof="ListItem"><a property="item" typeof="WebPage" title="お問い合わせ" href="/contact/" class="post post-page"><span property="name">お問い合わせ</span></a><meta property="position" content="2"></span> &gt; <span class="post post-page current-item">{{ hpConfig.category2_title[$route.params.category1] }}</span>
    </div>
<div class="p-section ctt-cnt aos-init aos-animate" data-aos="fade-up" data-aos-duration="1800">
        <form action="" method="post" id="form" name="myform" novalidate="novalidate">
            <div class="tbl">
                <p class="p-category-title">お問い合わせ</p>
                <h1 class="p-page-title">CONTACT</h1>
                <div v-if="$route.params.category1 == 0">
                    <div class="tbl-row">
                        <div class="tbl-col pls-mail">
                            お問い合わせサービス<span style="display:inline-block;">（複数選択可）</span>
                        </div>
                        <div class="tbl-col top pls-mail">
                            <div class="hinfo">必須</div>
                        </div>
                        <div class="tbl-col pls-mail">
                            <div v-for="(ct2, index) in hpConfig.category2_elment" v-bind:key="index" class="index_area">
                                <div class="tbl-col">
                                    <input type="checkbox" id="label" class="check">
                                    <label for="label" v-on:click="selectCategory2(ct2)" class="cat-element">&nbsp;&nbsp;&nbsp;&nbsp;<nobr v-html="ct2.label"></nobr></label>
                                    <div v-show="ct2.show" v-for="(ct3, i) in hpConfig.category3_elment[ct2.value-1]" v-bind:key="i">
                                            <label style="text-indent: 2em"><input type="checkbox" name="category3" value="ct3.value" v-on:click="selectCategory3(ct3)" :checked="ct3.checked"><nobr v-html="ct3.label"></nobr></label>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- <div v-if="hpConfig.category3_elment[2][1].checked"> -->
                    <div v-if="testCheck(2, 1)">
                    <hr>
                        <div class="tbl-row">
                            <div class="tbl-col pls-mail">データベースの種類</div>
                            <div class="tbl-col pls-mail">
                                <div class="hinfo">必須</div>
                            </div>
                            <div class="tbl-col pls-mail">
                                <select name="db_name" class="col-two" style="height: 3.6em; background-color: #F7F8FA;border-radius: 4px">
                                    <option value="1">MySQL</option>
                                    <option value="2">PostgreSQL</option>
                                </select>
                            </div>
                        </div>
                        <hr>
                        <div class="tbl-row">
                            <div class="tbl-col pls-mail">対象台数</div>
                            <div class="tbl-col pls-mail">
                                <div class="hinfo">必須</div>
                            </div>
                            <div class="tbl-col pls-mail">
                                <input type="text" name="server_count" placeholder="1" class="col-two">
                            </div>
                        </div>
                    </div>
                    <div v-if="testCheck(2, 2)">
                    <hr>
                        <div class="tbl-row">
                            <div class="tbl-col pls-mail">対象ホームページのURL</div>
                            <div class="tbl-col pls-mail">
                                <div class="hinfo">必須</div>
                            </div>
                            <div class="tbl-col pls-mail">
                                <input type="text" name="target_url" placeholder="https://www.example.com">
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="$route.params.category1 == 1">
                    <div class="tbl-row">
                        <div class="tbl-col pls-mail">
                            カテゴリ<span style="display:inline-block;">（複数選択可）</span>
                        </div>
                        <div class="tbl-col top pls-mail">
                            <div class="hinfo">必須</div>
                        </div>
                        <div class="tbl-col pls-mail">
                            <div v-for="(business, index) in hpConfig.category2_business_elment" v-bind:key="index">
                                <div class="tbl-col">
                                    <label style="text-indent: 2em"><input type="checkbox" name="category3" value="business.value" v-on:click="selectCategory3(business)" :checked="business.checked">{{ business.label }}</label>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div v-if="$route.params.category1 == 2">
                </div>
                <div class="pls-mail sugg_content" v-if="$route.params.category1 == 2">
                    <div style="text-align: center">
                        商品・サービスの内容が分かる資料など添付の上、下記電子メールアドレス宛にご連絡をお願いいたします。<br>
                        <img src="/contact/static/images/common/contact_mail.png" class="contact_img">
                    </div>
                </div>
            </div>
            <!-- 共通入力項目 -->
            <CommonFormInput v-if="$route.params.category1 != 2"/>
        </form>
  </div>
</div>
</template>
<script>
import CommonFormInput from '@/components/CommonFormInput'
import CommonMixin from '@/mixins'

export default {
  mixins: [CommonMixin],
  name: 'ContactCategory2',
  data () {
    return {
      categories: [
      ]
    }
  },
  methods: {
    moveCategorySelect2: function () {
      alert(1)
    },
    selectCategory2: function (elm) {
      elm.show = !elm.show
    },
    selectCategory3: function (elm) {
      elm.checked = !elm.checked
    },
    submitContact: function () {
      alert(1)
    },
    testCheck: function (main, sub) {
      if (this.hpConfig.category3_elment[main] !== undefined) {
        if (this.hpConfig.category3_elment[main][sub] !== undefined) {
          return this.hpConfig.category3_elment[main][sub].checked
        }
      }
      return false
    }
  },
  components: {CommonFormInput},
  async mounted () {
    // FIXME with wordpressの場合ここから
    /*
    this.hpConfig = await this.getCategory()
    for (const config of this.hpConfig.category2_elment) {
      this.hpConfig.category3_elment.push(await this.getServies(config.catId))
      // this.hpConfig.category3_elment[config.value - 1] = await this.getServies(config.catId)
    }
    */
    // FIXME with wordpressの場合ここまで
    if (this.contactIsFinish) {
      this.$router.push('/')
    }
    console.log(this.$route.query.id)
    if (this.$route.query.id !== undefined) {
      const params = this.$route.query.id.split('')
      if (this.$route.params.category1 === '0') {
        // FIXME with wordpressの場合ここから
        /*
        this.hpConfig.category3_elment.forEach(function (cat, index, list) {
          this.__categoryIndex = index
          cat.forEach(function (elm, index, list) {
            // TODO 特殊文字を置換する必要がある場合は随時追記
            var tmp = elm.label.replace(/&#038;/, '&')
            if (tmp === this.$route.query.name.replace(/&#038;/, '&')) {
              elm.checked = true
              this.index = this.__categoryIndex
            }
          }, this)
        }, this)
        */
        // FIXME with wordpressの場合ここまで
        // FIXME s3はこっち
        const index = parseInt(params[0]) - 1
        // FIXME with wordpressならこっち
        // const index = this.index
        this.hpConfig.category2_elment[index].show = true
        this.hpConfig.category3_elment[index].forEach(function (elm) {
          console.log(elm.label)
          if (elm.value === parseInt(params[1])) {
            elm.checked = true
          }
        })
      } else if (this.$route.params.category1 === '1') {
        const index = parseInt(params[0]) - 1
        this.hpConfig.category2_business_elment[index].checked = true
      }
    }
  }
}
</script>
<style scoped>
.pls-mail {
    text-align: left;
}
.cat-element {
    cursor: pointer;
}
.index_area {
    cursor: pointer;
}
.check {
display: none;
}
.index_area:before {
  content: "arrow_right";
  font-family: "Material Icons";
  font-size: 20px;
  position: absolute;
  transform: translateY(-14%);
}
.contact_img {
    width: 20%;
}
@media screen and (max-width:768px) {
    .contact_img {
        width: 40%;
    }
}
.sugg_content {
    margin-top: -50px
}
@media screen and (max-width:768px) {
    .sugg_content {
        margin-top: -20px
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ContactCategory2.vue